import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { initGA } from "@/lib/ga";
import { MyAuthProvider } from "./contexts/MyAuthContext";
import { CartProvider } from "./contexts/CartContext";
import MyLayout from "./components/MyLayout";
import MyHome from "./pages/MyHome";
import MyProfile from "./pages/MyProfile";
import MyFormadorAvaliacao from "./pages/MyFormadorAvaliacao";
import { MyOrders, MyOrderDetail } from "./pages/MyOrders";
import MySubscriptions from "./pages/MySubscriptions";
import MyWallet from "./pages/MyWallet";
import MyCommissions from "./pages/MyCommissions";
import MyMudarDeVida from "./pages/MyMudarDeVida";
import MyDownloads from "./pages/MyDownloads";
import MyNotifications from "./pages/MyNotifications";
import MyCart from "./pages/MyCart";
import MyCartAdd from "./pages/MyCartAdd";
import MyCartAction from "./pages/MyCartAction";
import MyOrderPayment from "./pages/MyOrderPayment";
import MyCheckout from "./pages/MyCheckout";
import MyCheckoutPayment from "./pages/MyCheckoutPayment";
import MyRecomendar from "./pages/MyRecomendar";
import MyRevenda from "./pages/MyRevenda";
import MyCursosDiplomas from "./pages/MyCursosDiplomas";
import CoachVirtual from "./pages/CoachVirtual";
import MyComoFunciona from "./pages/MyComoFunciona";
import MyEventos from "./pages/MyEventos";
import MyPropostas from "./pages/MyPropostas";
import MyAreaFormador from "./pages/MyAreaFormador";
import PageTracker from "@/components/PageTracker";

export default function MyApp() {
  useEffect(() => { initGA(); }, []);
  return (
    <MyAuthProvider>
      <CartProvider>
        <PageTracker source="my" />
        <Routes>
          {/* /my/login is deprecated — the unified /login handles auth for MY + MEDIA + CRM. */}
          <Route path="login" element={<Navigate to="/login" replace />} />
          <Route element={<MyLayout />}>
            <Route index element={<MyHome />} />
            <Route path="loja" element={<Navigate to="/loja" replace />} />
            <Route path="loja/:slug" element={<Navigate to="/loja" replace />} />
            <Route path="perfil" element={<MyProfile />} />
            <Route path="carrinho" element={<MyCart />} />
            <Route path="cart" element={<MyCart />} />
            <Route path="cart/add" element={<MyCartAdd />} />
            <Route path="cart/action" element={<MyCartAction />} />
            <Route path="checkout" element={<MyCheckout />} />
            <Route path="checkout/payment" element={<MyCheckoutPayment />} />
            <Route path="encomendas" element={<MyOrders />} />
            <Route path="encomendas/:id" element={<MyOrderDetail />} />
            <Route path="orders/:hash/payment" element={<MyOrderPayment />} />
            <Route path="subscricoes" element={<MySubscriptions />} />
            <Route path="carteira" element={<MyWallet />} />
            <Route path="comissoes" element={<MyCommissions />} />
            <Route path="recomendar" element={<MyRecomendar />} />
            <Route path="mudardevida" element={<MyMudarDeVida />} />
            <Route path="downloads" element={<MyDownloads />} />
            <Route path="cursos-diplomas" element={<MyCursosDiplomas />} />
            <Route path="area-formador" element={<MyAreaFormador />} />
            <Route path="coach" element={<CoachVirtual />} />
            <Route path="revenda" element={<MyRevenda />} />
            <Route path="eventos" element={<MyEventos />} />
            <Route path="propostas" element={<MyPropostas />} />
            <Route path="notificacoes" element={<MyNotifications />} />
            <Route path="como-funciona" element={<MyComoFunciona />} />
            <Route path="formador/curso/:id/avaliacao" element={<MyFormadorAvaliacao />} />
          </Route>
        </Routes>
      </CartProvider>
    </MyAuthProvider>
  );
}
